/* eslint-disable react/prop-types, react/jsx-props-no-spreading */

import React from 'react';
import { ConfigProvider } from 'antd'; // eslint-disable-line no-restricted-imports
import antdLocale from 'locales/antdLocale';

const CWOConfigProvider = ({ children, ...props }) => (
  <ConfigProvider
    locale={antdLocale()}
    theme={{
      token: {
        colorPrimary: '#0071cd',
      },
      components: {
        Modal: {
          motionDurationMid: '0s',
          motionDurationSlow: '0s',
        },
      },
    }}
    wave={{ disabled: true }}
    {...props}
  >
    {children}
  </ConfigProvider>
);

export default CWOConfigProvider;
